import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-store-customers-kpi',
    templateUrl: './store-customers-kpi.component.html',
    styleUrls: ['./store-customers-kpi.component.css']
})

//Pagina 29
export class StoreCustomersKpiComponent implements OnInit {
    show_results = false;

    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    public indicators: IndicatorBoxModel[] = [];
    public translations: any;
    public segmentDistributionChart: LoyaltyChart;
    public storeError = false;
    public selectOneError: string;
    public data: QFilterModel;

    constructor(
        private indicatorService: IndicatorsService,
        private chartsService: IndicatorsChartService,
        private svcAnalytics: AnalyticsService,
        private srvCustomerCampaign: CustomerCampaignService,
        private translate: TranslateService,
        private searchModelFactory: SearchToolbarModelFactoryService,
    ) {
        this.translate.get([
            'kpiChart.segmentDistribution',
            'kpiChart.selectedShop',
            'kpiChart.formatAverage',
            'kpiChart.axisTitle'
        ]).subscribe((t) => {
            this.translations = {
                segmentDistribution: t['kpiChart.segmentDistribution'],
                selectedShop: t['kpiChart.selectedShop'],
                formatAverage: t['kpiChart.formatAverage'],
                axisTitle: t['kpiChart.axisTitle']
            };
            this.initChart();
        });

        this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });


    }

    ngOnInit() {

    }

    initChart() {
        this.segmentDistributionChart = (new LoyaltyChart('bar', '%'));
        this.segmentDistributionChart.options.plotOptions = {series: {stacking: 'percent'}};
        this.segmentDistributionChart.options.title.text = this.translations.segmentDistribution;
        this.segmentDistributionChart.options.legend = {layout: "horizontal", align: "center", verticalAlign: "bottom", reversed: true};
    }

    setChartInstance(chart: LoyaltyChart, chartInstance) {
        chart.instance = chartInstance;
    }

    searchValue (data: QFilterModel) {
        this.data = data;

        if (data['stores'] != null) {
            this.translate.get([
                'indicator.n_clienti_loyalty',
                'indicator.n_clienti_profilabili',
                'indicator.fatturato_loyalty',
                'indicator.penetrazione_loy_valore',
                'indicator.n_clienti_nuovi',
                'indicator.n_clienti_nuovi_profilabili',
                'indicator.scontrini_loyalty',
                'indicator.penetrazione_loy_volume'
            ]).subscribe(t => {
                this.indicators = [];

                Observable.zip(
                    this.indicatorService.indicatorCalculation('stores.Q153', this.data),
                    this.indicatorService.indicatorCalculation('stores.Q155', this.data),
                    this.indicatorService.indicatorCalculation('stores.Q156', this.data),
                    this.indicatorService.indicatorCalculation('stores.Q157', this.data)
                ).subscribe(
                    ([a, b, c, d]) => {

                        /*153*/
                        this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'n_clienti_loyalty')], {dynamic: false, decimal_value: 0, decimal_prec_value: 0}, t));
                        /*154*/
                        this.indicators.push(new IndicatorBoxModel([a.find(r => r.name === 'n_clienti_profilabili')], {dynamic: false, decimal_value: 0, decimal_prec_value: 0}, t));
                        /*155*/
                        this.indicators.push(new IndicatorBoxModel([b.find(r => r.name === 'fatturato_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                        /*156*/
                        this.indicators.push(new IndicatorBoxModel([c.find(r => r.name === 'penetrazione_loy_valore')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));
                        /*157*/
                        this.indicators.push(new IndicatorBoxModel([d.find(r => r.name === 'n_clienti_nuovi')], {dynamic: false, decimal_value: 0, decimal_prec_value: 0}, t));
                        /*158*/
                        this.indicators.push(new IndicatorBoxModel([d.find(r => r.name === 'n_clienti_nuovi_profilabili')], {dynamic: false, decimal_value: 0, decimal_prec_value: 0}, t));
                        /*159*/
                        this.indicators.push(new IndicatorBoxModel([b.find(r => r.name === 'scontrini_loyalty')], {dynamic: false, decimal_value: 0, decimal_prec_value: 0}, t));
                        /*160*/
                        this.indicators.push(new IndicatorBoxModel([c.find(r => r.name === 'penetrazione_loy_volume')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));

                    });

            });
            this.segmentDistributionInit(data);
            this.show_results = true;

        } else {
            this.data = null;
            this.storeError = true;
        }

    }

    public toogleErrorStoreDialog() {
        this.storeError = !this.storeError;
    }

    public segmentDistributionInit (data) {

        Observable.zip (
            this.indicatorService.getChart('stores.Q161', data, false)
        ).subscribe( ([res]) => {

            let serie0 = res.series[0].serie;
            let serie1 = res.series[1].serie;
            let serie2 = res.series[2].serie;
            const xAxis = {
                serie: serie0.filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                })
            };

            let unique = serie1.filter( function (value, index, self) {
                return self.indexOf(value) === index;
            });
            let index = unique.length;
            let colors = ['#d9e3f6','#acc1e8','#7c9edc','#6189d5','#4573cd','#3563bc','#26437a','#267a5a'];
            let series: Array<any> = [];
            for (let i = 0; i < serie0.length; i++) {
                let elem = series.find(function (elem) {
                    return elem.name === serie1[i];
                });
                if (typeof elem === 'undefined') {
                    series.push({name: serie1[i], data: [serie2[i]], index: index, color: colors[(index-1)%8]});
                    index = index - 1;
                } else {
                    elem.data.push(serie2[i]);
                }
            }

            if (this.segmentDistributionChart.instance) {
                while (this.segmentDistributionChart.instance.series.length > 0) {
                    this.segmentDistributionChart.instance.series[0].remove(true);
                }
            }

            this.segmentDistributionChart.options.xAxis.categories = xAxis.serie;

            for (let i = 0; i < series.length; i++) {

                this.segmentDistributionChart.instance.addSeries(series[i]);
            }

            this.segmentDistributionChart.instance.update(this.segmentDistributionChart.options);
            this.segmentDistributionChart.instance.redraw();
        });



    }

    resetData() {
        this.show_results = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers-kpi/store-customers-kpi.component.ts